export class UserToCreate {
  public Ident: string;
  public civility: string;
  public firstName: string;
  public lastName: string;
  public password: string;
  public emailCnx: string;
  public emailGoogle: string;
  public emailMicrosoft: string;
  public idRole: string;
  public idBureau: string;
  public idsGroupes: Array<string>;
  constructor(datas: UserToCreate | null = null) {
    if (datas == null) {
      this.Ident = '';
      this.civility = '';
      this.firstName = '';
      this.lastName = '';
      this.password = '';
      this.emailCnx = '';
      this.emailGoogle = '';
      this.emailMicrosoft = '';
      this.idRole = '';
      this.idBureau = '';
      this.idsGroupes = [];
    } else {
      this.Ident = datas.Ident;
      this.civility = datas.civility;
      this.firstName = datas.firstName;
      this.lastName = datas.lastName;
      this.password = datas.password;
      this.emailCnx = datas.emailCnx;
      this.emailGoogle = datas.emailGoogle;
      this.emailMicrosoft = datas.emailMicrosoft;
      this.idRole = datas.idRole;
      this.idBureau = datas.idBureau;
      this.idsGroupes = datas.idsGroupes;
    }
  }

  public WithRandomPassword(length: number = 24): UserToCreate {
    this.password = this.generateRandomPassword(length);
    return this;
  }

  private generateRandomPassword(length: number = 24): string {
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const number = "1234567890";
    const special = "!@#$%^&*_-=+";
    let hasLower = false;
    let hasUpper = false;
    let hasNumber = false;
    let hasSpecial = false;
    // Build up a string using random bytes and character classes
    let res = "";
    for (let i = 0; i < length; i++) {
      //sélectionne un charactère aléatoire pour chaque ittération
      const weight: number = Math.random() * 4;
      // pondéré à ~33%
      if (weight < 1.3) { res += lower[Math.floor(Math.random() * lower.length)]; }
      // pondéré à ~33%
      else if (weight < 2.6) { res += upper[Math.floor(Math.random() * upper.length)]; }
      // pondéré à ~22%
      else if (weight < 3.5) { res += number[Math.floor(Math.random() * number.length)]; }
      // pondéré à ~12%
      else res += special[Math.floor(Math.random() * special.length)];
    }
    if (!hasLower)
      res += lower[Math.floor(Math.random() * lower.length)];
    if (!hasUpper)
      res += upper[Math.floor(Math.random() * upper.length)];
    if (!hasNumber)
      res += number[Math.floor(Math.random() * number.length)];
    if (!hasSpecial)
      res += special[Math.floor(Math.random() * special.length)];
    return res;
  }
}
